"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RadioButton = _interopRequireDefault(require("../RadioButton"));
var _RadioGroup = _interopRequireDefault(require("../RadioGroup/RadioGroup"));
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _messages = require("./messages");
var _getLanguage = _interopRequireDefault(require("../../utils/getLanguage"));
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _SelectList_css = _interopRequireDefault(require("./SelectList_css"));
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * SelectList component (Can use either checkboxes/radio buttons).
 *
 * There are two key values in this component:
 *  - Radio: selectedValue prop (only used for radio buttons)
 *  - Checkboxes: options prop (used for both radio buttons and checkboxes - see examples)
 *
 * @FormGroupCompatible
 * @class SelectList
 * @extends {Component}
 */
class SelectList extends _react.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    /**
     * Handler when clicking header of component. Flips "isOpen" flag and
     * initiates animation.
     *
     * @memberof SelectList
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleHeaderClick", () => {
      if (!this.props.isCollapsible) return;
      if (this.state.isOpen) {
        this.listContainer.style.setProperty("--containerHeight", "".concat(this.list.offsetHeight, "px"));
        setTimeout(() => {
          this.setState({
            isOpen: false
          });
        }, 5);
      } else {
        this.setState({
          isOpen: true
        });
        setTimeout(() => {
          this.listContainer.style.setProperty("--containerHeight", "auto");
        }, 500);
      }
    });
    /**
     * Handler when any row is clicked in list. Functionality differs slightly based
     * on whether list type is checkbox or radio. If row is disabled, return immediatly.
     *
     * @memberof SelectList
     * @param {number} index
     * @param {bool} isChecked
     * @param {bool} isDisabled
     */
    (0, _defineProperty2.default)(this, "handleRowClick", function (index, isChecked, isDisabled) {
      let isChild = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      let childIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
      if (isDisabled) return;
      if (_this.props.isRadio) {
        if ("onFormValueChanged" in _this.props) {
          _this.props.onFormValueChanged(_this.props.options[index].value);
        }
        if ("onChange" in _this.props) {
          _this.props.onChange({
            index: index,
            value: _this.props.options[index].value
          });
        }
      } else {
        if ("onFormValueChanged" in _this.props) {
          _this.props.onFormValueChanged(_this.props.options.map((option, i) => {
            if (i === index) {
              if (isChild) {
                return _objectSpread(_objectSpread({}, option), {}, {
                  children: (0, _immutabilityHelper.default)(option.children, {
                    [childIndex]: {
                      $set: _objectSpread(_objectSpread({}, option.children[childIndex]), {}, {
                        isChecked: !option.children[childIndex].isChecked
                      })
                    }
                  })
                });
              } else {
                return _objectSpread(_objectSpread({}, option), {}, {
                  isChecked: !option.isChecked
                });
              }
            } else {
              return option;
            }
          }));
        }
        if ("onChange" in _this.props) {
          _this.props.onChange({
            index: index,
            childIndex: childIndex,
            value: _this.props.options[index].value,
            isChecked: !isChecked
          });
        }
      }
    });
    (0, _defineProperty2.default)(this, "renderChildren", (parentIndex, children) => {
      const {
        isRadio,
        truncate,
        themeColor
      } = this.props;
      return children.map((option, i) => {
        const clickHandler = () => this.handleRowClick(parentIndex, option.isChecked, option.isDisabled, true, i);
        let rowProps = {
          className: "row child-element"
        };
        if (isRadio) {
          rowProps["onClick"] = clickHandler;
        }
        if (truncate) {
          rowProps["title"] = option.value;
        }
        return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          key: "select-list-child-opt-".concat(i)
        }, rowProps), isRadio ? /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
          label: option.label || option.value,
          name: option.name || option.value,
          isDisabled: option.isDisabled,
          themeColor: themeColor
        }) : /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          label: option.label || option.value,
          name: option.name || option.value,
          isDisabled: option.isDisabled,
          isChecked: option.isChecked,
          themeColor: themeColor,
          onChange: clickHandler
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "num-items t-body-med",
          dangerouslySetInnerHTML: {
            __html: this.formatNumOfOptions(option.numItems)
          }
        }));
      });
    });
    (0, _appendCss.default)("arc_slctlst", _SelectList_css.default);
    this.language = (0, _getLanguage.default)();
    this.listId = (0, _lodash.uniqueId)("selctlstel_");
    this.state = {
      isOpen: true
    };
  }
  formatNumOfOptions(numItems) {
    // format with span containing a space behind the value because Bozon font has a macro for
    // single digits wrapped with parens that turns the display into a circled value.
    return numItems && numItems !== "" ? "(".concat(numItems, ")") : "";
  }
  render() {
    const {
      options,
      header,
      isCollapsible,
      isRadio,
      name,
      selectedValue,
      truncate,
      themeColor,
      fontStyle
    } = this.props;
    const list = options.map((option, i) => {
      const clickHandler = () => this.handleRowClick(i, option.isChecked, option.isDisabled);
      let rowProps = {
        className: "row"
      };
      if (isRadio) {
        rowProps["onClick"] = clickHandler;
      }
      if (truncate) {
        rowProps["title"] = option.value;
      }
      if (!this.state.isOpen) return null;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: "select-list-opt-".concat(i)
      }, /*#__PURE__*/_react.default.createElement("div", rowProps, isRadio ? /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
        label: option.label || option.value,
        name: option.name || option.value,
        isDisabled: option.isDisabled,
        themeColor: themeColor
      }) : /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        label: option.label || option.value,
        name: option.name || option.value,
        isDisabled: option.isDisabled,
        isChecked: option.isChecked,
        themeColor: themeColor,
        onChange: clickHandler
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "num-items t-body-med",
        dangerouslySetInnerHTML: {
          __html: this.formatNumOfOptions(option.numItems)
        }
      })), "children" in option && !isRadio && this.renderChildren(i, option.children));
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "select-list__elem ".concat(truncate ? "truncate" : ""),
      role: "listbox"
    }, /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
      className: (0, _classnames.default)({
        "header": true,
        "non-collapsible": !isCollapsible
      }),
      onClick: this.handleHeaderClick
    }, isCollapsible && {
      "aria-expanded": this.state.isOpen,
      "aria-label": "".concat(header, ". ").concat(_messages.messages[this.language].toggle)
    }, !isCollapsible && {
      tabIndex: -1
    }), /*#__PURE__*/_react.default.createElement("h5", {
      id: this.listId,
      className: fontStyle
    }, header), isCollapsible && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _classnames.default)({
        "arrow-down": true,
        "point-up": !this.state.isOpen
      }),
      icon: "expand_more"
    })), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _classnames.default)({
        "list-container": true,
        "closed": !this.state.isOpen
      }),
      ref: node => this.listContainer = node
    }, isCollapsible && {
      "aria-expanded": this.state.isOpen
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "list",
      ref: node => this.list = node
    }, isRadio ? /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
      name: name,
      selectedValue: selectedValue,
      labelledby: this.listId
    }, list) : list)));
  }
}
SelectList.propTypes = {
  /** array representing selectable options */
  options: _propTypes.default.array.isRequired,
  /** custom change event handler */
  onChange: _propTypes.default.func,
  /** specifies whether list can be collapsed or not when clicking on the header */
  isCollapsible: _propTypes.default.bool,
  /** defaults to false: indicates whether to use radio buttons or checkboxes */
  isRadio: _propTypes.default.bool,
  /** selected value of radio group (not used with checkboxes) */
  selectedValue: _propTypes.default.string,
  /** HTML name attribute */
  name: _propTypes.default.string,
  /** specifies whether to use ellipses (...) or to overflow unto multiple lines for any row */
  truncate: _propTypes.default.bool,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"]),
  /** Font style for the SelectList heading. Any combination of the Font styles defined in the 'Fonts' section. Default: t-label-large */
  fontStyle: _propTypes.default.string
};
SelectList.defaultProps = {
  options: [],
  isCollapsible: true,
  isRadio: false,
  selectedValue: "",
  name: null,
  truncate: false,
  themeColor: "primary",
  fontStyle: "t-label-large"
};
var _default = exports.default = SelectList;